import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "~/css/Modal.css";
import { talkModes } from "~/Commons";
import { useAtom } from "jotai/index";
import { standbyModeAtom } from "~/Atom";
import * as icon from "~/Icons";

type ModalProps = {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: string | number;
  height?: string | number;
};

const Modal: React.FC<ModalProps> = ({ title, isOpen, onClose, children, width, height }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [, setStandbyMode] = useAtom(standbyModeAtom);

  useEffect(() => {
    if (isOpen) {
      setStandbyMode(talkModes.stopped);
      setIsVisible(true);
      setAnimationClass("animate-in");
      return () => {};
    } else {
      setAnimationClass("animate-out");
      // アニメーション終わった後に非表示
      const timer = setTimeout(() => setIsVisible(false), 400);
      return () => clearTimeout(timer);
    }
  }, [isOpen, setStandbyMode]);

  if (!isVisible) return null;

  const modalStyle: React.CSSProperties = {};
  if (width) modalStyle.width = typeof width === "number" ? `${width}px` : width;
  if (height) modalStyle.height = typeof height === "number" ? `${height}px` : height;

  const modalContent = (
    <div className={"modal-overlay"}>
      <div className={`modal-base ${animationClass}`} style={modalStyle}>
        <div className="modal-header font-default-bold-24">
          <h2>{title}</h2>
          <button className="modal-close-button" onClick={onClose} aria-label="close">
            <icon.icons_close />
          </button>
        </div>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );

  // ポータルを使ってdocument.bodyに直接レンダリング
  return createPortal(modalContent, document.body);
};

export default Modal;
